import { useCallback, useMemo } from 'react'

import { DEFAULT_WIDGET_AREA_ID } from 'features/views/LayoutEditor/constants'
import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'
import { useLayoutEditorWidgetAreaContext } from 'features/views/LayoutEditor/useLayoutEditorWidgetAreaContext'

type UseLayoutEditorWidgetAreaExtrasStateOptions = {
    id: string
}

export function useLayoutEditorWidgetAreaExtrasState(
    options: UseLayoutEditorWidgetAreaExtrasStateOptions
) {
    const { id } = options

    const { commands } = useLayoutEditorContext()
    const { children, path, isEditing, isDraggingAboveIdx } = useLayoutEditorWidgetAreaContext()!
    const childrenLength = children.length

    const onClickPlaceholderWidget = useCallback(
        (widgetType: string) => {
            commands.insertWidgetAtPath(widgetType, path)
        },
        [commands, path]
    )

    const isMainWidgetArea = id === DEFAULT_WIDGET_AREA_ID
    const isRootWidgetArea = path.length === 1

    return useMemo(
        () => ({
            childrenLength,
            isEditing,
            isDraggingAboveIdx,
            isMainWidgetArea,
            isRootWidgetArea,
            onClickPlaceholderWidget,
        }),
        [
            childrenLength,
            isEditing,
            isDraggingAboveIdx,
            isMainWidgetArea,
            isRootWidgetArea,
            onClickPlaceholderWidget,
        ]
    )
}
